import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  fetchBonusCampaigns,
  fetchBonusHistory,
  postAckBonus,
  postBonusExpiry,
  postClaimBonus,
} from '../../api/fetchers/bonusPromotions/fetchers';
import { fetchPromotionsJwt } from '../../api/fetchers/promotionsV2/fetcher';

export const fetchBonusCampaignsAction = createAsyncThunk('bonusPromotions/fetchBonusCampaigns', fetchBonusCampaigns);
export const fetchBonusHistoryAction = createAsyncThunk('bonusPromotions/fetchBonusHistoryAction', fetchBonusHistory);
export const postClaimBonusAction = createAsyncThunk('bonusPromotions/postClaimBonusAction', postClaimBonus);
export const postAckBonusAction = createAsyncThunk('bonusPromotions/postAckBonusAction', postAckBonus);
export const postBonusExpiryAction = createAsyncThunk('bonusPromotions/postBonusExpiry', postBonusExpiry);
export const fetchBonusCampaignsJwtAction = createAsyncThunk('bonusPromotions/fetchJwtToken', fetchPromotionsJwt);
